import { PageInfo } from './main.model';

export class ToggleSidenav {
	static readonly type = '[Main] ToggleSidenav';
}

export class StartLoading {
	static readonly type = '[Main] StartLoading';
}

export class StopLoading {
	static readonly type = '[Main] StopLoading';
}

export class SetShowSystemMessage {
	static readonly type = '[Main] SetShowSystemMessage';
	constructor(public show: boolean) {}
}

export class GetCurrentSystemMessages {
	static readonly type = '[Main] GetCurrentSystemMessages';
}

export class GetCrisisTeamRoleApproval {
	static readonly type = '[Main] GetCrisisTeamRoleApproval';
}

export class ApproveCrisisTeamRole {
	static readonly type = '[Main] ApproveCrisisTeamRole';
}

export class RejectCrisisTeamRole {
	static readonly type = '[Main] RejectCrisisTeamRole';
}

export class OmniSearch {
	static readonly type = '[Main] OmniSearch';
	constructor(public searchValue: string) {}
}

export class ClearOmniSearchResults {
	static readonly type = '[Main] ClearOmniSearchResults';
}

export class SetPageInfo {
	static readonly type = '[Main] SetPageInfo';
	constructor(public pageInfo: PageInfo) {}
}

export class GetCountries {
	static readonly type = '[Main] GetCountries';
}

export class SearchAirports {
	static readonly type = '[Main] SearchAirports';
	constructor(public search: string) {}
}

export class ClearAirports {
	static readonly type = '[Main] ClearAirports';
}

export class SearchAirlines {
	static readonly type = '[Main] SearchAirlines';
	constructor(public search: string) {}
}

export class ClearAirlines {
	static readonly type = '[Main] ClearAirlines';
}

export class SearchCities {
	static readonly type = '[Main] SearchCities';
	constructor(public search: string) {}
}

export class ClearCities {
	static readonly type = '[Main] ClearCities';
}

export class GetValidationSettings {
	static readonly type = '[Main] GetValidationSettings';
}

export class ShowSnackBarTimedMessage {
	static readonly type = '[Main] ShowSnackBarTimedMessage';
	constructor(public message: string, public error: boolean = false) {}
}

export class GetDepartments {
	static readonly type = '[Main] GetDepartments';
	constructor(public onlyEnabled: boolean) {}
}

export class GetHireTypes {
	static readonly type = '[Main] GetHireTypes';
}

export class GetPhoneNumberTypes {
	static readonly type = '[Main] GetPhoneNumberTypes';
}

export class GetExitPermitTypes {
	static readonly type = '[Main] GetExitPermitTypes';
}

export class GetDependentTypes {
	static readonly type = '[Main] GetDependentTypes';
}

export class GetDependentSchools {
	static readonly type = '[Main] GetDependentSchools';
}

export class GetFirstAidCPRTypes {
	static readonly type = '[Main] GetFirstAidCPRTypes';
}

export class GetEmergencyContactTypes {
	static readonly type = '[Main] GetEmergencyContactTypes';
}

export class GetCompounds {
	static readonly type = '[Main] GetCompounds';
}

export class GetUnitTypes {
	static readonly type = '[Main] GetUnitTypes';
}

export class GetAllowedPetTypes {
	static readonly type = '[Main] GetAllowedPetTypes';
}

export class GetVersionInfo {
	static readonly type = '[Main] GetVersionInfo';
}

export class GetCallingTreeUserHireTypes {
	static readonly type = '[Main] GetCallingTreeUserHireTypes';
}
